import React from 'react'
import styles from './styles.module.css'

const ChangelogTitle = ({ children }) => <h3 className={styles.changelogTitle}>{children}</h3>

export default ChangelogTitle
